import Http from "../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../core/HttpResponse";
import { IExpense } from "../Expense.type";

export const getListExpense = async ({
  keyword,
  expense_category_id,
  date_from,
  date_to,
  page,
  perPage,
}: HttpBaseRequest<{
  expense_category_id?: string;
  date_from?: string;
  date_to?: string;
}>) => {
  const res = await Http.get<HttpBaseResponse<HttpData<IExpense[]>>>({
    url: "/expense",
    params: {
      keyword,
      expense_category_id,
      date_from,
      date_to,
      page,
      perPage,
    },
  });
  return res;
};

export const getDetailExpense = async ({
  expense_id,
}: HttpBaseRequest<{ expense_id: string }>) => {
  const res = await Http.get<HttpBaseResponse<IExpense>>({
    url: "/expense/detail",
    params: {
      expense_id,
    },
  });
  return res;
};

export const addExpense = async ({
  name,
  description,
  expense_category_id,
  date,
  total_expense,
  is_using_ppn,
  ppn_expense_category_id,
  ppn_percentage,
}: {
  name: string;
  expense_category_id: string;
  description: string;
  total_expense: string;
  date: string;
  is_using_ppn?: boolean;
  ppn_expense_category_id?: number;
  ppn_percentage?: number;
}) => {
  const res = await Http.post({
    url: "/expense/insert",
    data: {
      name,
      expense_category_id,
      description,
      total_expense,
      date,
      is_using_ppn,
      ppn_expense_category_id,
      ppn_percentage,
    },
  });
  return res;
};

export const updateExpense = async ({
  expense_id,
  name,
  description,
  expense_category_id,
  date,
  total_expense,
  is_using_ppn,
  ppn_expense_category_id,
  ppn_percentage,
}: {
  expense_id: string;
  name: string;
  expense_category_id: string;
  description: string;
  total_expense: string;
  date: string;
  is_using_ppn?: boolean;
  ppn_expense_category_id?: number;
  ppn_percentage?: number;
}) => {
  const res = await Http.post({
    url: "/expense/update",
    data: {
      expense_id,
      name,
      description,
      expense_category_id,
      date,
      total_expense,
      is_using_ppn,
      ppn_expense_category_id,
      ppn_percentage,
    },
  });
  return res;
};

export const deleteExpense = async ({
  expense_id,
}: HttpBaseRequest<{ expense_id: string }>) => {
  const res = await Http.delete({
    url: `/expense/delete?expense_id=${expense_id}`,
  });
  return res;
};
